export default __webpack_public_path__ + "c03407a842bc0eec63edb7adf77b583d.png";